module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAMCAYAAABbayygAAAABHNCSVQICAgIfAhkiAAAAKZJREFUGFe1kF0RwjAQhL9tBVAJWMABOEBCJBQFtApAQhwggUrAAeAAA811rp3yU5i+cQ/J3GZv97JiUhay0iHFdHx/0thYYA35Hvy2B6iBtlbk0g/6YYEt5KeXgkXgDo6nUpFGFiggu4KK6RpgO6BUTEsnuuX5m9R7RVCAdqVheR1+E0e03TixAvknZuqPxHlj0O0Z+JBn5kEvhjGrFVM1SnwQ53Q7+Zo22rmxkQ0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dian.png
// module id = 3rtB
// module chunks = 9